import { comparisonData } from "@/mocks/categories";

export default function ComparisonSection() {
  return (
    <section id="comparison" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <p className="text-xs font-semibold uppercase tracking-wider text-accent-600 mb-2">Why Choose Us</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            VigorBuy Spreadsheet vs <span className="text-accent-500">Manual Search</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            See why thousands of shoppers trust our spreadsheet over searching manually
          </p>
        </div>

        {/* Table */}
        <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden">
          {/* Header Row */}
          <div className="grid grid-cols-3 bg-background-100 border-b border-background-200">
            <div className="p-4 text-sm font-semibold text-foreground-950">Feature</div>
            <div className="p-4 text-sm font-semibold text-accent-600 text-center">
              <i className="ri-checkbox-circle-fill mr-1.5"></i>
              Our Spreadsheet
            </div>
            <div className="p-4 text-sm font-semibold text-foreground-500 text-center">
              Manual Search
            </div>
          </div>

          {/* Data Rows */}
          {comparisonData.map((row, idx) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-background-100 ${
                idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
              }`}
            >
              <div className="p-4 text-sm text-foreground-700 font-medium">{row.feature}</div>
              <div className="p-4 text-center">
                {row.spreadsheet ? (
                  <span className="inline-flex items-center gap-1 text-accent-600 text-sm font-semibold">
                    <i className="ri-check-line"></i> Yes
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-foreground-400 text-sm">
                    <i className="ri-close-line"></i> No
                  </span>
                )}
              </div>
              <div className="p-4 text-center">
                {row.manual ? (
                  <span className="inline-flex items-center gap-1 text-accent-600 text-sm font-semibold">
                    <i className="ri-check-line"></i> Yes
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-foreground-400 text-sm">
                    <i className="ri-close-line"></i> No
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}